<template>
  <div>
    <b-overlay
        :show="pageOverlay"
        rounded="sm"
        opacity="0.65"
        spinner-variant="primary"
    >
      <b-row>
        <b-col cols="12">
          <b-card>
            <div
                class="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-2"
            >
              <div>
                <h4 class="mb-50">
                  مدیریت سرفصل‌ها
                </h4>
              </div>

              <div
                  class="d-flex flex-wrap align-items-center mt-1 mt-md-0"
              >
                <b-badge
                    v-if="isValidObjectId"
                    variant="light-primary"
                    class="product-title-badge mr-1"
                >
                  {{ displayProductTitle }}
                </b-badge>

                <b-button
                    variant="outline-secondary"
                    @click="goBack"
                >
                  بازگشت

                  <feather-icon
                      icon="ArrowLeftIcon"
                      size="16"
                      class="ml-50"
                  />
                </b-button>
              </div>
            </div>
            <b-alert
                v-if="pageError"
                show
                dismissible
                variant="danger"
                class="mb-2"
                @dismissed="pageError = ''"
            >
              {{ pageError }}
            </b-alert>

            <validation-observer ref="createFormObserver">
              <b-form @submit.prevent="validateCreateForm">
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                        label="عنوان سرفصل"
                        label-for="topic-title"
                        class="mb-1"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="عنوان سرفصل"
                          rules="required"
                      >
                        <b-form-input
                            id="topic-title"
                            ref="titleInput"
                            v-model="createForm.title"
                            :state="errors.length ? false : null"
                            :disabled="createLoading || !isValidObjectId"
                            maxlength="200"
                            autocomplete="off"
                            placeholder="مثلاً مقدمه و آشنایی با دوره"
                            @input="pageError = ''"
                        />

                        <small
                            v-if="errors.length"
                            class="d-block mt-50 text-danger"
                        >
                          عنوان سرفصل را وارد کنید.
                        </small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <div
                    class="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between mt-1"
                >

                  <b-button
                      type="submit"
                      variant="primary"
                      class="px-2"
                      :block="isMobile"
                      :disabled="createLoading || !isValidObjectId"
                  >
                    <b-spinner
                        v-if="createLoading"
                        small
                        class="mr-50"
                    />

                    <feather-icon
                        v-else
                        icon="PlusIcon"
                        size="17"
                        class="mr-50"
                    />

                    ثبت سرفصل
                  </b-button>
                </div>
              </b-form>
            </validation-observer>
          </b-card>

          <b-card class="mt-2">
            <div
                class="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-2"
            >
              <div>
                <h4 class="mb-50">
                  فهرست سرفصل‌ها
                </h4>

                <p class="mb-0 text-muted">
                  مجموع
                  {{ formatNumber(totalCount) }}
                  سرفصل برای
                  {{ displayProductTitle }}
                  ثبت شده است.
                </p>
              </div>

              <div
                  class="d-flex flex-wrap align-items-center mt-1 mt-md-0"
              >
                <b-form-select
                    :value="perPage"
                    :options="perPageOptions"
                    class="topic-count-select mr-1"
                    :disabled="topicsLoading"
                    @input="changePerPage"
                />
              </div>
            </div>

            <div
                v-if="topicsLoading"
                class="topics-loading"
            >
              <b-spinner
                  variant="primary"
                  label="در حال دریافت سرفصل‌ها"
              />

              <span class="mt-1 text-muted">
                                در حال دریافت سرفصل‌ها...
                            </span>
            </div>

            <b-list-group v-else-if="topics.length">
              <b-list-group-item
                  v-for="(topic, index) in topics"
                  :key="topic.topicId"
                  class="topic-item"
              >
                <div class="topic-item__main">
                  <b-badge
                      variant="light-primary"
                      class="topic-number"
                  >
                    {{ getTopicNumber(index) }}
                  </b-badge>

                  <div class="topic-item__content">
                    <h6 class="topic-item__title">
                      {{ topic.title }}
                    </h6>

                    <div class="topic-item__meta">
                                            <span>
                                                محصول:
                                                {{
                                                topic.productTitle ||
                                                displayProductTitle
                                              }}
                                            </span>

                      <span>
                                                تعداد مدیا:
                                                {{
                          formatNumber(
                              topic.mediasCount
                          )
                        }}
                                            </span>

                      <span
                          v-if="topic.createdAt"
                      >
                                                تاریخ ایجاد:
                                                {{
                          formatDate(
                              topic.createdAt
                          )
                        }}
                                            </span>

                      <b-badge
                          :variant="
                                                    topic.isActive
                                                        ? 'light-success'
                                                        : 'light-secondary'
                                                "
                      >
                        {{
                          topic.isActive
                              ? "فعال"
                              : "غیرفعال"
                        }}
                      </b-badge>
                    </div>
                  </div>
                </div>

                <div class="topic-item__actions">
                  <b-button
                      size="sm"
                      variant="outline-primary"
                      :disabled="
                                            editLoading ||
                                            deleteLoading
                                        "
                      @click="openEditModal(topic)"
                  >
                    <feather-icon
                        icon="EditIcon"
                        size="15"
                        class="mr-50"
                    />

                    ویرایش
                  </b-button>

                  <b-button
                      size="sm"
                      variant="outline-danger"
                      :disabled="
                                            editLoading ||
                                            deleteLoading
                                        "
                      @click="openDeleteModal(topic)"
                  >
                    <feather-icon
                        icon="Trash2Icon"
                        size="15"
                        class="mr-50"
                    />

                    حذف
                  </b-button>
                </div>
              </b-list-group-item>
            </b-list-group>

            <div
                v-else
                class="empty-topics"
            >
              <div class="empty-topics__icon">
                <feather-icon
                    icon="ListIcon"
                    size="30"
                />
              </div>

              <h5 class="mt-1 mb-50">
                هنوز سرفصلی ثبت نشده است
              </h5>

              <p class="mb-0 text-muted">
                عنوان اولین سرفصل را در فرم بالا وارد کنید.
              </p>
            </div>

            <div
                v-if="totalCount > perPage"
                class="topics-pagination"
            >
              <b-pagination
                  :value="currentPage"
                  :total-rows="totalCount"
                  :per-page="perPage"
                  first-number
                  last-number
                  align="center"
                  class="mb-0"
                  @input="changePage"
              />
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-modal
          ref="editTopicModal"
          centered
          hide-footer
          title="ویرایش سرفصل"
          no-close-on-backdrop
          @hidden="resetEditForm"
      >
        <validation-observer ref="editFormObserver">
          <b-form @submit.prevent="validateEditForm">
<!--            <b-form-group-->
<!--                label="نام محصول"-->
<!--                label-for="edit-product-title"-->
<!--            >-->
<!--              <b-form-input-->
<!--                  id="edit-product-title"-->
<!--                  :value="displayProductTitle"-->
<!--                  disabled-->
<!--              />-->
<!--            </b-form-group>-->

            <b-form-group
                label="عنوان سرفصل"
                label-for="edit-topic-title"
            >
              <validation-provider
                  #default="{ errors }"
                  name="عنوان سرفصل"
                  rules="required"
              >
                <b-form-input
                    id="edit-topic-title"
                    ref="editTitleInput"
                    v-model="editForm.title"
                    maxlength="200"
                    autocomplete="off"
                    :state="
                                        errors.length
                                            ? false
                                            : null
                                    "
                    :disabled="editLoading"
                    placeholder="عنوان سرفصل را وارد کنید"
                />

                <small
                    v-if="errors.length"
                    class="text-danger"
                >
                  عنوان سرفصل را وارد کنید.
                </small>
              </validation-provider>
            </b-form-group>

            <div
                class="d-flex flex-column flex-sm-row justify-content-end mt-2"
            >
              <b-button
                  type="button"
                  variant="outline-secondary"
                  class="mb-1 mb-sm-0 mr-sm-1"
                  :disabled="editLoading"
                  @click="closeEditModal"
              >
                انصراف
              </b-button>

              <b-button
                  type="submit"
                  variant="primary"
                  :disabled="editLoading"
              >
                <b-spinner
                    v-if="editLoading"
                    small
                    class="mr-50"
                />

                <feather-icon
                    v-else
                    icon="SaveIcon"
                    size="16"
                    class="mr-50"
                />

                ذخیره تغییرات
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-modal>

      <b-modal
          ref="deleteTopicModal"
          centered
          hide-footer
          title="حذف سرفصل"
          no-close-on-backdrop
          @hidden="resetDeleteForm"
      >
        <div class="delete-modal-content">
          <div class="delete-modal-icon">
            <feather-icon
                icon="AlertTriangleIcon"
                size="28"
            />
          </div>

          <h5>
            آیا از حذف این سرفصل مطمئن هستید؟
          </h5>

          <p
              v-if="deleteForm.title"
              class="mb-50 text-muted"
          >
            «{{ deleteForm.title }}»
          </p>

          <small class="text-muted">
            محصول:
            {{ displayProductTitle }}
          </small>
        </div>

        <div
            class="d-flex flex-column flex-sm-row justify-content-end mt-2"
        >
          <b-button
              type="button"
              variant="outline-secondary"
              class="mb-1 mb-sm-0 mr-sm-1"
              :disabled="deleteLoading"
              @click="closeDeleteModal"
          >
            انصراف
          </b-button>

          <b-button
              type="button"
              variant="danger"
              :disabled="deleteLoading"
              @click="deleteTopic"
          >
            <b-spinner
                v-if="deleteLoading"
                small
                class="mr-50"
            />

            <feather-icon
                v-else
                icon="Trash2Icon"
                size="16"
                class="mr-50"
            />

            حذف سرفصل
          </b-button>
        </div>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import {
  BAlert,
  BBadge,
  BButton,
  BCard,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BListGroup,
  BListGroupItem,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BSpinner,
} from "bootstrap-vue";

import {
  ValidationObserver,
  ValidationProvider,
} from "vee-validate";

import { required } from "@validations";

import ToastificationContent from "@core/components/toastification/ToastificationContent";

import {
  CreateProductTopics,
  DeleteProductTopics,
  GetAllProductTopics,
  UpdateProductTopics,
} from "@/libs/Api/Product";

export default {
  name: "AddProductTopics",

  title: "مدیریت سرفصل‌ها - پنل ادمین بنفشه باقری",

  components: {
    BAlert,
    BBadge,
    BButton,
    BCard,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BListGroup,
    BListGroupItem,
    BModal,
    BOverlay,
    BPagination,
    BRow,
    BSpinner,
    ValidationObserver,
    ValidationProvider,
  },

  data() {
    return {
      required,
      objectId: null,
      productTitle: "",
      topicsLoading: false,
      createLoading: false,
      editLoading: false,
      deleteLoading: false,
      pageError: "",
      topics: [],
      totalCount: 0,
      currentPage: 1,
      perPage: 10,
      contextInitialized: false,
      storageKeys: {
        objectId: "product-topics-object-id",
        productTitle: "product-topics-product-title",
      },
      perPageOptions: [
        {
          value: 5,
          text: "۵ مورد",
        },
        {
          value: 10,
          text: "۱۰ مورد",
        },
        {
          value: 20,
          text: "۲۰ مورد",
        },
        {
          value: 50,
          text: "۵۰ مورد",
        },
      ],
      createForm: {
        title: "",
      },
      editForm: {
        topicId: null,
        title: "",
      },
      deleteForm: {
        topicId: null,
        title: "",
      },
    };
  },

  computed: {
    pageOverlay() {
      return (
          this.createLoading ||
          this.editLoading ||
          this.deleteLoading
      );
    },

    isMobile() {
      return (
          this.$store.getters[
              "app/currentBreakPoint"
              ] === "xs"
      );
    },

    isValidObjectId() {
      return (
          Number.isFinite(
              Number(this.objectId)
          ) &&
          Number(this.objectId) > 0
      );
    },

    displayProductTitle() {
      const title = String(
          this.productTitle || ""
      ).trim();

      if (title) {
        return title;
      }

      if (this.isValidObjectId) {
        return "محصول انتخاب‌شده";
      }

      return "محصول نامشخص";
    },

    normalizedCreateTitle() {
      return this.normalizeTitle(
          this.createForm.title
      );
    },

    normalizedEditTitle() {
      return this.normalizeTitle(
          this.editForm.title
      );
    },
  },

  watch: {
    "$route.query.objectId"() {
      this.handleRouteChange();
    },

    "$route.query.productTitle"() {
      this.handleRouteChange();
    },

    "$route.params.id"() {
      this.handleRouteChange();
    },
  },

  async mounted() {
    this.initializeContext();

    if (this.isValidObjectId) {
      await this.getTopics();
    }

    this.contextInitialized = true;
    this.focusCreateInput();
  },

  methods: {
    fetchRequest(request) {
      return new Promise((resolve, reject) => {
        try {
          request.fetch(resolve, reject);
        } catch (error) {
          reject(error);
        }
      });
    },

    initializeContext() {
      const routeObjectId =
          this.getRouteObjectId();

      const storedObjectId =
          this.getStoredObjectId();

      const routeProductTitle =
          this.getRouteProductTitle();

      const storedProductTitle =
          this.getStoredProductTitle();

      this.objectId =
          routeObjectId ||
          storedObjectId ||
          null;

      this.productTitle =
          routeProductTitle ||
          storedProductTitle ||
          "";

      this.persistContext();
    },

    async handleRouteChange() {
      if (!this.contextInitialized) {
        return;
      }

      const previousObjectId =
          Number(this.objectId);

      this.initializeContext();

      if (
          Number(this.objectId) !==
          previousObjectId
      ) {
        this.currentPage = 1;
        this.topics = [];
        this.totalCount = 0;

        if (this.isValidObjectId) {
          await this.getTopics();
        }
      }
    },

    getRouteObjectId() {
      const params =
          this.$route.params || {};

      const query =
          this.$route.query || {};

      const value = Number(
          query.objectId ||
          query.productId ||
          params.objectId ||
          params.productId ||
          params.id
      );

      return (
          Number.isFinite(value) &&
          value > 0
              ? value
              : null
      );
    },

    getRouteProductTitle() {
      const query =
          this.$route.query || {};

      return String(
          query.productTitle ||
          query.title ||
          ""
      ).trim();
    },

    getStoredObjectId() {
      if (!process.client) {
        return null;
      }

      const value = Number(
          sessionStorage.getItem(
              this.storageKeys.objectId
          )
      );

      return (
          Number.isFinite(value) &&
          value > 0
              ? value
              : null
      );
    },

    getStoredProductTitle() {
      if (!process.client) {
        return "";
      }

      return String(
          sessionStorage.getItem(
              this.storageKeys.productTitle
          ) || ""
      ).trim();
    },

    persistContext() {
      if (!process.client) {
        return;
      }

      if (this.isValidObjectId) {
        sessionStorage.setItem(
            this.storageKeys.objectId,
            String(this.objectId)
        );
      }

      if (this.productTitle) {
        sessionStorage.setItem(
            this.storageKeys.productTitle,
            this.productTitle
        );
      }
    },

    updateProductTitle(value) {
      const title = String(
          value || ""
      ).trim();

      if (!title) {
        return;
      }

      this.productTitle = title;
      this.persistContext();
    },

    normalizeTitle(value) {
      return String(value || "")
          .replace(/\s+/g, " ")
          .trim();
    },

    getTopicsRequestBody() {
      return {
        objectId: Number(this.objectId),
        pageNumber:
            Number(this.currentPage) || 1,
        count:
            Number(this.perPage) || 10,
      };
    },

    async getTopics(options) {
      const settings =
          options || {};

      const silent = Boolean(
          settings.silent
      );

      if (!this.isValidObjectId) {
        this.topics = [];
        this.totalCount = 0;

        if (!silent) {
          this.showErrorToast(
              "محصول معتبر نیست."
          );
        }

        return;
      }

      this.topicsLoading = true;
      this.pageError = "";

      const request =
          new GetAllProductTopics(this);

      request.setParams(
          this.getTopicsRequestBody()
      );

      try {
        const content =
            await this.fetchRequest(request);

        if (
            content &&
            content.isSuccess === false
        ) {
          throw new Error(
              content.errorMessage ||
              "دریافت سرفصل‌ها انجام نشد."
          );
        }

        const result =
            this.extractTopicsResult(
                content
            );

        this.topics =
            result.topics;

        this.totalCount =
            result.totalCount;

        this.updateProductTitle(
            result.productTitle
        );

        if (
            !this.topics.length &&
            this.currentPage > 1
        ) {
          this.currentPage -= 1;

          await this.getTopics({
            silent: true,
          });
        }
      } catch (error) {
        console.error(
            "Get all topics error:",
            error
        );

        this.topics = [];
        this.totalCount = 0;

        const message =
            this.getErrorMessage(
                error,
                "دریافت سرفصل‌ها انجام نشد."
            );

        this.pageError = message;

        if (!silent) {
          this.showErrorToast(message);
        }
      } finally {
        this.topicsLoading = false;
      }
    },

    extractTopicsResult(content) {
      const responseData =
          content &&
          content.data &&
          typeof content.data ===
          "object"
              ? content.data
              : {};

      const rawTopics =
          Array.isArray(
              responseData.data
          )
              ? responseData.data
              : [];

      const topics = rawTopics
          .map((topic) =>
              this.normalizeTopic(topic)
          )
          .filter(Boolean);

      const total =
          Number(responseData.total);

      const topicWithProductTitle =
          topics.find((topic) =>
              Boolean(topic.productTitle)
          );

      const productTitle =
          String(
              responseData.productTitle ||
              (
                  topicWithProductTitle &&
                  topicWithProductTitle.productTitle
              ) ||
              ""
          ).trim();

      return {
        topics,
        totalCount:
            Number.isFinite(total) &&
            total >= 0
                ? total
                : topics.length,
        productTitle,
      };
    },

    normalizeTopic(topic) {
      if (
          !topic ||
          typeof topic !== "object"
      ) {
        return null;
      }

      const topicId =
          Number(topic.topicId);

      if (!topicId) {
        return null;
      }

      const objectId =
          Number(topic.objectId) ||
          Number(this.objectId);

      const order =
          Number(topic.order);

      return {
        ...topic,
        topicId,
        objectId,
        productTitle:
            String(
                topic.productTitle ||
                this.productTitle ||
                ""
            ).trim(),
        title:
            String(
                topic.title || ""
            ).trim(),
        order:
            Number.isFinite(order)
                ? order
                : null,
        isActive:
            Boolean(topic.isActive),
        mediasCount:
            Number(topic.mediasCount) ||
            0,
        createdAt:
            topic.createdAt || null,
      };
    },

    getTopicNumber(index) {
      return (
          (this.currentPage - 1) *
          this.perPage +
          index +
          1
      );
    },

    async changePage(page) {
      const pageNumber =
          Number(page);

      if (
          !pageNumber ||
          pageNumber ===
          this.currentPage
      ) {
        return;
      }

      this.currentPage =
          pageNumber;

      await this.getTopics();
    },

    async changePerPage(value) {
      const count =
          Number(value);

      if (
          !count ||
          count === this.perPage
      ) {
        return;
      }

      this.perPage = count;
      this.currentPage = 1;

      await this.getTopics();
    },

    validateCreateForm() {
      this.pageError = "";

      this.$refs.createFormObserver
          .validate()
          .then((success) => {
            if (!success) {
              return;
            }

            if (!this.isValidObjectId) {
              this.showErrorToast(
                  "محصول معتبر نیست."
              );

              return;
            }

            if (
                this.normalizedCreateTitle
                    .length < 2
            ) {
              this.showErrorToast(
                  "عنوان سرفصل باید حداقل ۲ کاراکتر باشد."
              );

              this.focusCreateInput();

              return;
            }

            if (
                this.normalizedCreateTitle
                    .length > 200
            ) {
              this.showErrorToast(
                  "عنوان سرفصل نباید بیشتر از ۲۰۰ کاراکتر باشد."
              );

              return;
            }

            this.createTopic();
          });
    },

    async createTopic() {
      if (this.createLoading) {
        return;
      }

      const duplicate =
          this.topics.some((topic) => {
            return (
                this.normalizeTitle(
                    topic.title
                ).toLocaleLowerCase() ===
                this.normalizedCreateTitle
                    .toLocaleLowerCase()
            );
          });

      if (duplicate) {
        this.showErrorToast(
            "سرفصلی با این عنوان قبلاً ثبت شده است."
        );

        return;
      }

      this.createLoading = true;
      this.pageError = "";

      const request =
          new CreateProductTopics(this);

      request.setParams({
        objectId:
            Number(this.objectId),
        title:
        this.normalizedCreateTitle,
      });

      try {
        const content =
            await this.fetchRequest(request);

        if (
            content &&
            content.isSuccess === false
        ) {
          throw new Error(
              content.errorMessage ||
              "ایجاد سرفصل انجام نشد."
          );
        }

        this.createForm.title = "";
        this.currentPage = 1;

        if (
            this.$refs.createFormObserver
        ) {
          this.$refs
              .createFormObserver
              .reset();
        }

        await this.getTopics({
          silent: true,
        });

        this.showSuccessToast(
            "سرفصل با موفقیت ایجاد شد."
        );

        this.focusCreateInput();
      } catch (error) {
        const message =
            this.getErrorMessage(
                error,
                "ایجاد سرفصل انجام نشد."
            );

        this.pageError = message;
        this.showErrorToast(message);
      } finally {
        this.createLoading = false;
      }
    },

    openEditModal(topic) {
      const topicId =
          Number(
              topic &&
              topic.topicId
          );

      if (!topicId) {
        this.showErrorToast(
            "شناسه سرفصل معتبر نیست."
        );

        return;
      }

      this.editForm = {
        topicId,
        title:
            String(
                topic.title || ""
            ),
      };

      this.$refs
          .editTopicModal
          .show();

      this.$nextTick(() => {
        setTimeout(() => {
          const input =
              this.$refs
                  .editTitleInput;

          if (
              input &&
              typeof input.focus ===
              "function"
          ) {
            input.focus();
          }
        }, 150);
      });
    },

    closeEditModal() {
      if (this.editLoading) {
        return;
      }

      this.$refs
          .editTopicModal
          .hide();
    },

    resetEditForm() {
      this.editForm = {
        topicId: null,
        title: "",
      };

      if (
          this.$refs.editFormObserver
      ) {
        this.$refs
            .editFormObserver
            .reset();
      }
    },

    validateEditForm() {
      this.$refs.editFormObserver
          .validate()
          .then((success) => {
            if (!success) {
              return;
            }

            if (
                !Number(
                    this.editForm.topicId
                )
            ) {
              this.showErrorToast(
                  "شناسه سرفصل معتبر نیست."
              );

              return;
            }

            if (
                this.normalizedEditTitle
                    .length < 2
            ) {
              this.showErrorToast(
                  "عنوان سرفصل باید حداقل ۲ کاراکتر باشد."
              );

              return;
            }

            if (
                this.normalizedEditTitle
                    .length > 200
            ) {
              this.showErrorToast(
                  "عنوان سرفصل نباید بیشتر از ۲۰۰ کاراکتر باشد."
              );

              return;
            }

            this.updateTopic();
          });
    },

    async updateTopic() {
      if (this.editLoading) {
        return;
      }

      const topicId =
          Number(
              this.editForm.topicId
          );

      if (!topicId) {
        this.showErrorToast(
            "شناسه سرفصل معتبر نیست."
        );

        return;
      }

      const duplicate =
          this.topics.some((topic) => {
            return (
                Number(topic.topicId) !==
                topicId &&
                this.normalizeTitle(
                    topic.title
                ).toLocaleLowerCase() ===
                this.normalizedEditTitle
                    .toLocaleLowerCase()
            );
          });

      if (duplicate) {
        this.showErrorToast(
            "سرفصلی با این عنوان قبلاً ثبت شده است."
        );

        return;
      }

      this.editLoading = true;

      const request =
          new UpdateProductTopics(this);

      request.setParams({
        topicId,
        title:
        this.normalizedEditTitle,
      });

      try {
        const content =
            await this.fetchRequest(request);

        if (
            content &&
            content.isSuccess === false
        ) {
          throw new Error(
              content.errorMessage ||
              "ویرایش سرفصل انجام نشد."
          );
        }

        this.$refs
            .editTopicModal
            .hide();

        await this.getTopics({
          silent: true,
        });

        this.showSuccessToast(
            "سرفصل با موفقیت ویرایش شد."
        );
      } catch (error) {
        const message =
            this.getErrorMessage(
                error,
                "ویرایش سرفصل انجام نشد."
            );

        this.showErrorToast(message);
      } finally {
        this.editLoading = false;
      }
    },

    openDeleteModal(topic) {
      const topicId =
          Number(
              topic &&
              topic.topicId
          );

      if (!topicId) {
        this.showErrorToast(
            "شناسه سرفصل معتبر نیست."
        );

        return;
      }

      this.deleteForm = {
        topicId,
        title:
            String(
                topic.title || ""
            ),
      };

      this.$refs
          .deleteTopicModal
          .show();
    },

    closeDeleteModal() {
      if (this.deleteLoading) {
        return;
      }

      this.$refs
          .deleteTopicModal
          .hide();
    },

    resetDeleteForm() {
      this.deleteForm = {
        topicId: null,
        title: "",
      };
    },

    async deleteTopic() {
      if (this.deleteLoading) {
        return;
      }

      const topicId =
          Number(
              this.deleteForm.topicId
          );

      if (!topicId) {
        this.showErrorToast(
            "شناسه سرفصل معتبر نیست."
        );

        return;
      }

      this.deleteLoading = true;

      const request =
          new DeleteProductTopics(this);

      request.setParams({
        topicId,
      });

      try {
        const content =
            await this.fetchRequest(request);

        if (
            content &&
            content.isSuccess === false
        ) {
          throw new Error(
              content.errorMessage ||
              "حذف سرفصل انجام نشد."
          );
        }

        this.$refs
            .deleteTopicModal
            .hide();

        if (
            this.topics.length === 1 &&
            this.currentPage > 1
        ) {
          this.currentPage -= 1;
        }

        await this.getTopics({
          silent: true,
        });

        this.showSuccessToast(
            "سرفصل با موفقیت حذف شد."
        );
      } catch (error) {
        const message =
            this.getErrorMessage(
                error,
                "حذف سرفصل انجام نشد."
            );

        this.showErrorToast(message);
      } finally {
        this.deleteLoading = false;
      }
    },

    getErrorMessage(error, fallback) {
      const responseData =
          error &&
          error.response &&
          error.response.data;

      const validationErrors =
          responseData &&
          responseData.errors;

      let validationMessage = "";

      if (
          validationErrors &&
          typeof validationErrors ===
          "object"
      ) {
        const firstError =
            Object.values(
                validationErrors
            )[0];

        validationMessage =
            Array.isArray(firstError)
                ? firstError[0]
                : firstError;
      }

      return (
          (
              error &&
              error.message
          ) ||
          (
              responseData &&
              (
                  responseData.errorMessage ||
                  responseData.message
              )
          ) ||
          validationMessage ||
          fallback
      );
    },

    formatNumber(value) {
      return new Intl.NumberFormat(
          "fa-IR"
      ).format(
          Number(value) || 0
      );
    },

    formatDate(value) {
      if (!value) {
        return "";
      }

      const date =
          new Date(value);

      if (
          Number.isNaN(
              date.getTime()
          )
      ) {
        return "";
      }

      return new Intl.DateTimeFormat(
          "fa-IR",
          {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }
      ).format(date);
    },

    focusCreateInput() {
      this.$nextTick(() => {
        const input =
            this.$refs.titleInput;

        if (
            input &&
            typeof input.focus ===
            "function"
        ) {
          input.focus();
        }
      });
    },

    goBack() {
      if (
          process.client &&
          window.history.length > 1
      ) {
        this.$router.back();

        return;
      }

      this.$router.push({
        name: "apps-e-commerce-shop",
      });
    },

    showSuccessToast(message) {
      this.$toast({
        component:
        ToastificationContent,
        position:
            "bottom-center",
        props: {
          title:
              "عملیات موفق",
          icon:
              "CheckIcon",
          variant:
              "success",
          text:
          message,
        },
      });
    },

    showErrorToast(message) {
      this.$toast({
        component:
        ToastificationContent,
        position:
            "bottom-center",
        props: {
          title:
              "عملیات ناموفق",
          icon:
              "AlertCircleIcon",
          variant:
              "danger",
          text:
          message,
        },
      });
    },
  },
};
</script>

<style scoped>
.product-title-badge {
  display: inline-flex;
  min-height: 36px;
  max-width: 320px;
  padding: 8px 13px;
  align-items: center;
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.topic-count-select {
  width: 110px;
}

.topics-loading {
  display: flex;
  min-height: 220px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.topic-item {
  display: flex;
  min-height: 76px;
  padding: 14px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.topic-item__main {
  display: flex;
  min-width: 0;
  flex: 1;
  align-items: center;
  gap: 12px;
}

.topic-number {
  display: inline-flex;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
}

.topic-item__content {
  min-width: 0;
  flex: 1;
}

.topic-item__title {
  margin: 0 0 7px;
  overflow: hidden;
  color: #403648;
  font-size: 14px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.topic-item__meta {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #8d8692;
  font-size: 11px;
  flex-wrap: wrap;
}

.topic-item__actions {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
}

.topics-pagination {
  display: flex;
  margin-top: 24px;
  justify-content: center;
}

.empty-topics {
  display: flex;
  min-height: 260px;
  padding: 30px 20px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  background: #fbfafc;
  border: 1px dashed #ddd5e3;
  border-radius: 12px;
}

.empty-topics__icon {
  display: flex;
  width: 62px;
  height: 62px;
  align-items: center;
  justify-content: center;
  color: #7367f0;
  background: rgba(115, 103, 240, 0.1);
  border-radius: 16px;
}

.delete-modal-content {
  display: flex;
  min-height: 170px;
  padding: 12px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.delete-modal-icon {
  display: flex;
  width: 62px;
  height: 62px;
  margin-bottom: 16px;
  align-items: center;
  justify-content: center;
  color: #ea5455;
  background: rgba(234, 84, 85, 0.1);
  border-radius: 50%;
}

@media (max-width: 767px) {
  .product-title-badge {
    width: 100%;
    max-width: none;
    margin-right: 0 !important;
    margin-bottom: 8px;
    justify-content: center;
  }

  .topic-count-select {
    width: 100px;
  }

  .topic-item {
    align-items: flex-start;
    flex-direction: column;
  }

  .topic-item__main {
    width: 100%;
  }

  .topic-item__meta {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }

  .topic-item__actions {
    width: 100%;
  }

  .topic-item__actions .btn {
    flex: 1;
  }
}
</style>